/**
 * Decode JWT token and extract claims
 */
export function decodeJWT(token: string) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.warn('[JWT] Invalid token format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    // Handle UTF-8 properly - atob gives us Latin1, need to convert to UTF-8
    const decoded = JSON.parse(decodeURIComponent(atob(payload).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('')));
    return decoded;
  } catch (error) {
    console.error('[JWT] Failed to decode token:', error);
    return null;
  }
}

/** Claims of the Customer API token: `sub` = account id, `name` = display name, `role` = Customer or Doctor. */
export function extractUserFromToken(token: string) {
  const decoded = decodeJWT(token);
  if (!decoded) return null;

  return {
    userId: decoded.sub,
    username: decoded.name,
    displayName: decoded.name,
    accountType: decoded.role,
  };
}

/** Which portal a token belongs to. Unknown tokens have no portal, so they get null. */
export function roleFromToken(token: string | null): 'customer' | 'doctor' | null {
  if (!token) return null;
  const type = String(decodeJWT(token)?.role ?? '').toLowerCase();
  return type === 'doctor' ? 'doctor' : type === 'customer' ? 'customer' : null;
}

/** Seconds until the token expires (negative when it already has), or null when it carries no `exp`. */
export function secondsUntilExpiry(token: string, nowMs: number = Date.now()): number | null {
  const exp = Number(decodeJWT(token)?.exp);
  return Number.isFinite(exp) && exp > 0 ? Math.floor(exp - nowMs / 1000) : null;
}
